import type { PlanStatus } from './priceSimulationModel';

export const matchesStatusFilter = (statusIds: (string | number)[], planStatus: PlanStatus, isModified: boolean, isKept: boolean): boolean => {
    if (statusIds.length === 0 || statusIds.includes('All')) return true;

    const isDraft = planStatus === 'Draft';

    return statusIds.some((statusId) => {
        switch (statusId) {
            case 'Draft':
                return isDraft && (isModified || isKept);
            case 'Kept':
                return isKept;
            case 'NotHandled':
                return isDraft && !isModified && !isKept;
            case 'PendingReview':
            case 'Approved':
            case 'Rejected':
                return planStatus === statusId;
            default:
                return false;
        }
    });
};
